module.exports = __webpack_public_path__ + "static/media/contract_download.44b8b948.svg";